// eslint-disable-next-line import/no-anonymous-default-export
export default class {
  static authGrid = { mt: 4, mx: 2 };
  static container = { p: 2 };
  static homeIcons = "40px";
  static listIcons = "small";
  static settingIcons = "large";
  static accDetailIcons = { fontSize: "20px" };
  static profileIcons = { fontSize: "20px" };
  static accDetailText = { fontSize: "16px" };
  static marginY1 = { marginTop: 1, marginBottom: 1 };
  static marginY2 = { marginTop: 10, marginBottom: 10 };
  static listItemPrimaryText = { fontSize: "14px" };
  static listItemSecondaryText = {
    fontSize: "12px",
  };
}
